import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Header from "./components/Header";
import HomePage from "./pages/HomePage";

import "./styles/_global.css"

function App() {
  const [trains, setTrains] = useState(null);
  const [startStation, setStartStation] = useState('');
  const [endStation, setEndStation] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSearchResults = (searchResults, start, end) => {
    setTrains(searchResults);
    setStartStation(start);
    setEndStation(end);
  };

  const handleError = (errorMessage) => {
    setError(errorMessage);
  };

  const handleLoading = (isLoading) => {
    setLoading(isLoading);
  };

  return (
    <BrowserRouter>
      <Header 
        onSearchResults={handleSearchResults}
        onError={handleError}
        onLoading={handleLoading}
      />
      <main>
        <Routes>
          <Route 
            path="/" 
            element={
              <HomePage 
                trains={trains}
                startStation={startStation}
                endStation={endStation}
                error={error}
                loading={loading}
              />
            } 
          />
        </Routes>
      </main>
    </BrowserRouter>
  )
}

export default App;
